import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import YatAnimatedOutline from '@pkg/components/Sections/Profile/AnimatedOutline';

interface ThumbnailProps {
    $nft?: string;
    $enabled?: boolean;
    $draggable?: boolean;
    $highlight?: boolean;
    $preview?: boolean;
    $disabled?: boolean;
    $animatedOutline?: boolean;
}

export const LiquidIDThumbnail = styled(motion.div)<ThumbnailProps>`
    ${({ $nft, theme }) =>
        $nft
            ? css`
                  background-image: url(${$nft});
                  background-position: center center;
                  background-repeat: no-repeat;
                  background-size: cover;
                  outline: 2px solid ${theme.colors.transparent};
              `
            : css`
                  outline: 2px solid ${theme.colors.purple};
                  background-color: ${theme.shades.purple[20]};
              `}

    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-radius: 10px;
    z-index: 50;

    ${({ $highlight, theme }) =>
        $highlight &&
        css`
            transition: outline ${theme.transitions.speeds.rapid}s ${theme.transitions.easesCss.cubic}
                ${theme.transitions.speeds.rapid}s;
            outline: 2px solid ${theme.colors.purple};
        `}

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}

    ${({ $draggable }) =>
        $draggable &&
        css`
            cursor: grab;
        `}

    ${({ $enabled, $nft }) =>
        !$nft &&
        !$enabled &&
        css`
            opacity: 0.2;

            > div {
                cursor: initial;
                pointer-events: none;
            }
        `}

        ${({ $preview }) =>
        $preview &&
        css`
            width: 64px;
            height: 64px;
        `}

        ${({ $animatedOutline }) =>
        $animatedOutline &&
        css`
            outline-color: transparent;
            background-color: ${({ theme }) => theme.shades.purple[60]};
        `}

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 64px;
        height: 64px;

        ${({ $nft }) =>
            !$nft &&
            css`
                cursor: pointer;
            `}

        ${({ $preview }) =>
            $preview &&
            css`
                width: 64px;
                height: 64px;
            `}
    }
`;

interface SvgWrapperProps {
    $addIcon: boolean;
}

export const SvgWrapper = styled.div<SvgWrapperProps>`
    cursor: pointer;
    position: absolute;
    backdrop-filter: blur(14px);
    width: 30px;
    height: 30px;
    display: grid;
    place-content: center;
    border-radius: 50%;
    background: ${({ theme }) => theme.shades.white['10']};
    z-index: 55;

    ${({ $addIcon, theme }) =>
        $addIcon
            ? css`
                  > svg {
                      width: 30px;
                      height: 30px;

                      fill: ${theme.colors.purple};
                  }
              `
            : css`
                  transform: translate(25%, -25%);
                  width: 30px;
                  height: 30px;
                  top: 0;
                  right: 0;

                  > svg {
                      width: 14px;
                      height: 2px;
                  }
              `}
`;

export const HighlightMarker = styled(motion.div)`
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 7px solid ${({ theme }) => theme.colors.purple};
    border-radius: 10px;
`;

export const StyledAnimatedOutline = styled(YatAnimatedOutline)`
    border-radius: 10px;
`;
